<template>
  <div>
    <vx-card>
      <div class="flex flex-row gap-y-5" >
        <div class="h4 flex" style="align-items: center">
          <div id="print-label">
            <p class="flex" style="align-items: center">기본문서관리</p>
          </div>
        </div>
      </div>

      <div class="my-page-body mt-8">
        <div class="my-page-item">
          <span>기본 회사명 설정</span>
          <div class="gap-5">
            <field-selector v-model="field.field_id" :field-name="field.field_name" @select="onSelectField"/>

            <div>
              <vs-button v-if="saveable.field" color="secondary" @click="onClickSave('field')">저장</vs-button>
              <span v-else-if="saved.field" class="saved">{{saved.field}}</span>
              <span v-else-if="error.field" class="error">{{error.field}}</span>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import FileUploader from "@/components/FileUploader.vue";
import SignField from "@/components/SignField.vue";
import FieldSelector from "@/components/selector/FieldSelector.vue";

export default {
  name: "MyPageDocumentUpdate",
  components: {
    FieldSelector,
    SignField,
    FileUploader
  },

  computed: {
    myInfo() {
      return this.$store.state.auth.userInfo;
    },
    saveable() {
      const field = (this.oldField.field_id !== this.field.field_id)
      return {field}
    }
  },
  data() {
    return {
      prefixKey: 'document',
      field: {
        meta_id: 0,
        field_id: 0,
        field_name: '',
      },

      oldField: {
        meta_id: 0,
        field_id: 0,
        field_name: '',
      },

      saved: {
        field: '',
      },

      error: {
        field: '',
      },
    };
  },

  created() {
    this.loadUserInfo();
  },
  methods: {
    onClickSave (metaKey) {
      this.saveField(metaKey);
    },
    onSelectField (field) {
      this.field.field_id = field.id || 0;
      this.field.field_name = field.field_name;

      if (this.saveable.field) {
        this.saved.field = '';
        this.error.field = '';
      }
    },
    saveField (metaKey) {
      if (this.saveable[metaKey]) {
        const key = `${this.prefixKey}_${metaKey}`;
        const value = JSON.stringify({
          field_id: this.field.field_id,
          field_name: this.field.field_name,
        });
        const metaId = this.field.meta_id;
        if (metaId > 0) {
          this.$store.dispatch("member/UPDATE_META", { metaId, key, value}).then((data) => {
            this.saved[metaKey] = "저장되었습니다.";
            this.initOldData(metaKey)
          }).catch((error) => {
            this.error[metaKey] = "저장에 실패했습니다.";
            console.log("saveField error", error)
          });
        } else {
          this.$store.dispatch("member/CREATE_META", { key, value}).then((data) => {
            this.saved[metaKey] = "저장되었습니다.";
            this.initOldData(metaKey)
          }).catch((error) => {
            this.error[metaKey] = "저장에 실패했습니다.";
            console.log("saveField error", error)
          });
        }
      }
    },
    loadUserInfo() {
      this.$store.dispatch("member/LOAD_META").then((metaList) => {
        if (metaList && metaList.length > 0) {
          for (const meta of metaList) {
            // 중복된 key 가 있을 경우, 마지막에 저장된 데이터 사용
            if (meta.meta_key === `${this.prefixKey}_field`) {
              const value = JSON.parse(meta.meta_value);
              this.field.meta_id = meta.id;
              this.field.field_id = value.field_id;
              this.field.field_name = value.field_name;

              this.oldField.meta_id = meta.id;
              this.oldField.field_id = value.field_id;
              this.oldField.field_name = value.field_name;
            }
          }
        }
      }).catch((error) => {
      });
    },

    initOldData(metaKey) {
      if (metaKey === 'field') {
        this.oldField.field_id = this.field.field_id;
        this.oldField.field_name = this.field.field_name;
      }
    }
  },
};
</script>

<style scoped lang="scss">
.my-page-body {
  display: grid;
  gap: 1rem;

  & .my-page-item {
    display: grid;
    grid-template-columns: 140px 1fr;
    gap: 10px;

    & > span{
      line-height: 2.5;
      color: #3C3C3C;
      font-size: 16px;
      font-weight: 500;
    }

    & > div{
      display: flex;
      justify-content: left;
      align-content: center;
    }

    p.warning,
    p.danger {
      display: flex;
      align-items: center;
      gap: 4px;
      font-size: 14px;
      font-weight: 500;
    }
    p.warning { color: #3C3C3C; }
    p.danger { color: #EA5455; }
  }
}

.saved,
.error {
  line-height: 2.5rem;
}
.saved { color: #6670cb }
.error { color: red }


</style>
